import _ from 'lodash';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Form, Icon } from 'semantic-ui-react';
import { FormContext } from '../../../cnr/contexts/FormContext';
import { FrameworkContext } from '../../../cnr/contexts/FrameworkContent';
import { ParentContext } from '../../../cnr/contexts/ParentContext';
import { formatItem, formatTypes } from '../../../common/dateFormatting';
import FullPageWrapper from '../../../wrappers/FullPageWrapper';
import { ScheduleCalendar } from '../../calendar/Calendar';
import { FormItemContext } from '../FormItem';

const DateInput = (props) => {

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { currentSettings_state } = states
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { dataOptions } = aps_global ?? {}
  const { dataFormat } = dataOptions ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { frameworkRightType } = framework_state ?? {}

  const { form_state = {}, form_handlers = {} } = useContext(FormContext) ?? {};
  const { data_localForm } = form_state;
  const { handlePropPush, handleItemAdd } = form_handlers;

  // FormItemContext
  const { formItem_state = {} } = useContext(FormItemContext) ?? {};
  const { fip = {}, itemProp = {}, themeColors } = formItem_state;
  const { key: key_prop } = itemProp;

  // Form value
  const formValue = data_localForm?.[key_prop] ?? '';
  const _fip = { ...fip, value: formValue };

  const currentFip = useMemo(() => {
    if (!_.isEmpty(fip)) {
      return fip
    } else if (props.fip) {
      return props.fip
    }
  })

  const { propname } = currentFip ?? {}
  const trueDate = currentFip && currentFip.value ? new Date(currentFip.value) : null
  const formattedDate = trueDate ? formatItem(formatTypes.fullDate, currentFip.value) : ''
  delete currentFip.value;
  delete currentFip.key;

  currentFip.value = formattedDate

  // local state 
  const [inputDate, setInputDate] = useState(formattedDate)
  const [showCalendar, setShowCalendar] = useState()

  useEffect(() => {
    setInputDate(currentFip.value ? currentFip.value : '')
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentFip.value]);

  useEffect(() => {
    const _selectedDate = inputDate ? formatItem(dataFormat ? dataFormat : formatTypes.shortestDate, inputDate) : inputDate
    const data = {
      propname: fip.propname,
      value: _selectedDate
    }
    fip.onChange && fip.onChange(null, data)
    setShowCalendar()
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [inputDate]);

  const handleDateSelect = (d) => setInputDate(d)
  const handleShowCalendar = () => setShowCalendar(!showCalendar)

  const content = () => <ScheduleCalendar handleDateSelect={handleDateSelect} inputDate={inputDate} {...props} />

  const fullPageWrapper = () => <FullPageWrapper
    content={content()}
    topperCaption={'Select Date'}
    topperCaption2={_.startCase(propname)}
    handleCancel={handleShowCalendar}
    isBack={true}
  />

  const calContent = () => {
    if (frameworkRightType) {
      return content()
    } else {
      return fullPageWrapper()
    }
  }

  return showCalendar ?
    calContent() :
    <Form.Input {...currentFip}
      icon={<Icon name='calendar' color='grey' />}
      fluid
      onClick={() => handleShowCalendar()}
    />

}

export default DateInput